import React, {useEffect, useState} from "react";

// ICONS
import * as FaIcons from "react-icons/fa"; //Now i get access to all the icons
import * as AiIcons from "react-icons/ai";

import { IconContext } from "react-icons";
import { Navigate } from 'react-router-dom';
// ROUTING

import { Link } from "react-router-dom";

// DATA FILE
import { SidebarData } from "./data";

// STYLES
import "./navbar.css";

import {useTranslation} from "react-i18next";
import BASIC_INFORMATION from "../../core/data/basic";
import * as ReactGA from "react-ga";
import {TbDots, TbDotsVertical} from "react-icons/tb";
// import useAnalyticsEventTracker from "../../service/g-analytics/useAnalyticsEventTracker";

export default function Navbar() {

    const { t, i18n } = useTranslation();

    const [sidebar, setSidebar] = useState(false);

    const showSidebar = () => setSidebar(!sidebar);

    const [scroll, setScroll] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });

        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    // const gaEventTracker = useAnalyticsEventTracker('Navbar');

    return (
        <div className={'d-block d-md-none'}>
            <IconContext.Provider value={{ color: "#FFF" }}>
                <div className={scroll || window.location.pathname !== '/' ? "navbar bg-custom" : ""}>

                    <div className={sidebar ? 'd-none' : 'menu-bars m-auto1 fixed-top1 pt- ml-0 p-1 '}>

                        <a href="#" onClick={showSidebar} className={'border border-opacity-10 rounded-3 p-1 pt-0'}>
                            {/*<Language />*/}
                            <TbDotsVertical color={'black'} />
                            {/*<TbDots color={'black'} />*/}
                        </a>
                    </div>
                </div>
                <nav className={sidebar ? "nav-menu active shadow-lg" : "nav-menu"}>
                    <ul className="nav-menu-items text-start" onClick={showSidebar}>
                        <li className="navbar-toggle flex-column pt-4 mb-5">
                            <div className="d-flex mb-5">
                                <img src="/assets/img/logo/logo.png" className={'img-fluid'} width={'50'} alt="logo"/>
                                <span className={'text-white'}>
                                    <b>{t('my.name')}</b> <br/>
                                    Software Developer
                                </span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <div className="text-white m-4">
                                    <h3>{t('nav.menu')}</h3>
                                </div>
                                <div className={'m-4'}>
                                    <Link to="#" className="menu-bars">
                                        <AiIcons.AiOutlineClose className={'main-color'} />
                                    </Link>
                                </div>
                            </div>
                        </li>

                        <br/><br/><br/>

                        {SidebarData.map((item, index) => {
                            return (
                                <li key={index} className={item.cName}>
                                    {
                                        item.title === 'Resume'
                                            ?
                                            <a
                                                // onClick={()=>gaEventTracker('menu-item' + item.title)}
                                               href={item.path} target={'_blank'}>
                                                {item.icon}
                                                <span>{t('nav.' + item.title.toLowerCase())}</span>
                                            </a>
                                            :
                                            <Link to={item.path}>
                                                {item.icon}
                                                <span>{t('nav.' + item.title.toLowerCase())}</span>
                                            </Link>
                                    }
                                </li>
                            );
                        })}

                        <li className={'p-3 mb-4'}>
                            {/*<a onClick={()=>gaEventTracker('phone-kyivstar')} href={'tel.:' + BASIC_INFORMATION.phoneKyivstar} className={'align-items-center'}> <FaIcons.FaMobileAlt /> <label className={'p-2'}>*/}
                            {/*    /!*{BASIC_INFORMATION.phoneKyivstar}*!/*/}
                            {/*    Call me*/}
                            {/*</label></a> <br/>*/}
                            {/*/!*<a onClick={()=>gaEventTracker('phone-lifecell')} href={'tel.:' + BASIC_INFORMATION.phoneLifecell}> <FaIcons.FaMobileAlt /> <label className={'p-2'}>{BASIC_INFORMATION.phoneLifecell}</label></a> <br/>*!/*/}
                            {/*<a onClick={()=>gaEventTracker('mail')} href={*/}
                            {/*    'mailto:' + BASIC_INFORMATION.email + '?subject=Q&A-Menu'*/}
                            {/*}> <FaIcons.FaEnvelope /> <label className={'p-2'}>*/}
                            {/*    /!*{BASIC_INFORMATION.email.substr(0, 22)}*!/*/}
                            {/*    Write email*/}
                            {/*</label></a> <br/>*/}
                        </li>

                        <li className={'d-flex justify-content-between align-items-center text-white'}>
                            <p className={
                                'p-3'
                            }><br/>{t('nav.copyright')} © {(new Date().getFullYear())}.  {t('my.name')}.</p>
                        </li>
                    </ul>
                </nav>
            </IconContext.Provider>
        </div>
    );
}
